import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DeletedNetworkResponse, WifiInfo, WifiNetworkModel, WifiNetworkResponse, WifiNetworks, WifiStatus } from '@models/wifi-network/wifi-network.model';
import { SiqPopupHelper } from '@shared/utils/helpers/siq-popup.helper';
import { Observable, catchError, map, throwError } from 'rxjs';
import { EnvironmentsService } from './environments.service';
import { MixpanelService } from './mixpanel.service';
import { SiqApiService } from './siq-api.service';
import { SplashScreenService } from './splash-screen.service';

@Injectable({
  providedIn: 'root'
})
export class WifiService extends SiqApiService {

  constructor(
    httpClient: HttpClient,
    environmentService: EnvironmentsService,
    mixpanelService: MixpanelService,
    siqPopupHelper: SiqPopupHelper,
    splashScreenService: SplashScreenService) {
    super(httpClient, environmentService, mixpanelService, siqPopupHelper, splashScreenService);
  }

  getWifiNetworks(): Observable<WifiNetworks> {
    return this.makeSiqRequest<WifiNetworks, object>('wifi', 'siq',  {}, 'GET', false).pipe(
      map((response : WifiNetworks | HttpErrorResponse) => {
        if(response instanceof HttpErrorResponse) {
          throw response;
        }
        return response;
      }),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    )
  }

  addWifiNetwork(data: WifiNetworkModel): Observable<WifiNetworkResponse> {
    return this.makeSiqRequest<WifiNetworkResponse, WifiNetworkModel>('wifi', 'siq',  data, 'POST', false).pipe(
      map((response : WifiNetworkResponse | HttpErrorResponse) => {
        if(response instanceof HttpErrorResponse) {
          throw response;
        }
        return response;
      }),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    )
  }

  deleteWifiNetwork(wifiId: string): Observable<DeletedNetworkResponse> {
    return this.makeSiqRequest<DeletedNetworkResponse, object>(`wifi/${wifiId}`, 'siq',  {}, 'DELETE', false).pipe(
      map((response : DeletedNetworkResponse | HttpErrorResponse) => {
        if(response instanceof HttpErrorResponse) {
          throw response;
        }
        return response;
      }),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    )
  }

  getWifiStatus(bedId: string): Observable<WifiStatus> {
    return this.makeSiqRequest<WifiStatus, object>(`bed/${bedId}/wifiStatus`, 'siq',  {}, 'GET', false).pipe(
      map((response : WifiStatus | HttpErrorResponse) => {
        if(response instanceof HttpErrorResponse) {
          throw response;
        }
        return response;
      }),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    )
  }

  getWifiInfo(bedId: string): Observable<WifiInfo> {
    return this.makeSiqRequest<WifiInfo, object>(`bed/${bedId}/wifiInfo`, 'siq',  {}, 'GET', false).pipe(
      map((response : WifiInfo | HttpErrorResponse) => {
        if(response instanceof HttpErrorResponse) {
          throw response;
        }
        return response;
      }),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    )
  }
}
